import React, { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";

const VUOTO = { ragione_sociale: "", piva: "", telefono: "", email: "", referente: "" };

export function NuovoFornitoreDialog({ open, onClose, onCreated }) {
  const qc = useQueryClient();
  const [f, setF] = useState(VUOTO);
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));
  const mut = useMutation({
    mutationFn: async () => (await api.post("/fornitori", f)).data,
    onSuccess: (forn) => { toast.success("Fornitore creato"); qc.invalidateQueries({ queryKey: ["fornitori"] }); onCreated(forn); setF(VUOTO); },
    onError: (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)),
  });
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="nuovo-fornitore-dialog">
        <DialogHeader><DialogTitle className="font-display">Nuovo fornitore</DialogTitle><DialogDescription>Verrà selezionato automaticamente nell'articolo. Potrai completare gli altri dati in Anagrafica.</DialogDescription></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2 space-y-1.5"><Label>Ragione sociale *</Label><Input value={f.ragione_sociale} onChange={(e) => set("ragione_sociale", e.target.value)} data-testid="nf-ragione-sociale" /></div>
          <div className="space-y-1.5"><Label>P.IVA</Label><Input value={f.piva} onChange={(e) => set("piva", e.target.value)} data-testid="nf-piva" /></div>
          <div className="space-y-1.5"><Label>Telefono</Label><Input value={f.telefono} onChange={(e) => set("telefono", e.target.value)} data-testid="nf-telefono" /></div>
          <div className="space-y-1.5"><Label>Email</Label><Input value={f.email} onChange={(e) => set("email", e.target.value)} data-testid="nf-email" /></div>
          <div className="space-y-1.5"><Label>Referente</Label><Input value={f.referente} onChange={(e) => set("referente", e.target.value)} data-testid="nf-referente" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="nf-annulla">Annulla</Button>
          <Button onClick={() => (f.ragione_sociale.trim() ? mut.mutate() : toast.error("Inserisci la ragione sociale"))} disabled={mut.isPending} data-testid="nf-salva">Salva fornitore</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
